import { render, staticRenderFns } from "./distributionLevelConfig.vue?vue&type=template&id=9731a22c&scoped=true&"
import script from "./distributionLevelConfig.vue?vue&type=script&lang=js&"
export * from "./distributionLevelConfig.vue?vue&type=script&lang=js&"
import style0 from "./distributionLevelConfig.vue?vue&type=style&index=0&id=9731a22c&lang=scss&scoped=true&"
import style1 from "./distributionLevelConfig.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9731a22c",
  null
  
)

export default component.exports